import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

export const EmptyCardsState = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center py-8">
      <div className="text-center text-gray-500">
        <FileText className="w-12 h-12 mx-auto mb-4 text-gray-300" />
        <div className="text-base">
          {t("contractorCards.contractor.noCards")}
        </div>
      </div>
    </div>
  );
};
